import type { PropertyNumber } from '../models'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { propertyBaseSchema } from './propertyBaseSchema'
import { propertyTypeSchema } from './propertyTypeSchema'
import { z } from 'zod'

export const propertyNumberSchema = z
  .lazy(() => propertyBaseSchema)
  .and(
    z.object({
      type: z.lazy(() => propertyTypeSchema),
      min: z.number().optional(),
      max: z.number().optional(),
    }),
  ) as unknown as ToZod<PropertyNumber>

export type PropertyNumberSchema = PropertyNumber